import { AccountBalance, Assessment, TrendingUp } from "@mui/icons-material";
import { Card, CardContent } from "../../../../../components/ui/card";
import { AntecipationStats } from "../types";

interface AntecipationStatsSectionProps {
  stats: AntecipationStats;
  selectedDate: string;
}

export function AntecipationStatsSection({
  stats,
  selectedDate,
}: AntecipationStatsSectionProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);
  };

  const formatNumber = (value: number) => {
    return new Intl.NumberFormat("pt-BR").format(value);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-foreground">
        Resumo de Antecipações - {selectedDate}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="min-h-[140px]">
          <CardContent className="p-6 flex flex-col justify-between h-full">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-muted-foreground mb-2">
                  Valor Total Antecipado
                </p>
                <p className="text-2xl font-bold text-foreground">
                  {formatCurrency(stats.valorTotal)}
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <AccountBalance className="w-8 h-8 text-primary" />
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="min-h-[140px]">
          <CardContent className="p-6 flex flex-col justify-between h-full">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-muted-foreground mb-2">
                  Total de Registros
                </p>
                <p className="text-2xl font-bold text-foreground">
                  {formatNumber(stats.totalRegistros)}
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <Assessment className="w-8 h-8 text-primary" />
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="min-h-[140px]">
          <CardContent className="p-6 flex flex-col justify-between h-full">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-muted-foreground mb-2">
                  Status Atual
                </p>
                <p className="text-2xl font-bold text-foreground">
                  {stats.status}
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <TrendingUp className="w-8 h-8 text-primary" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
